var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c(
        "v-toolbar",
        { attrs: { dense: "", dark: "", color: "primary" } },
        [_c("v-toolbar-title", [_vm._v(_vm._s(_vm.title))])],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-text",
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  model: {
                    value: _vm.isValidForm,
                    callback: function ($$v) {
                      _vm.isValidForm = $$v
                    },
                    expression: "isValidForm",
                  },
                },
                [_c("div", [_vm._t("default")], 2)]
              ),
              _vm._v(" "),
              _c(
                "v-alert",
                {
                  staticClass: "mx-0 mt-3",
                  attrs: {
                    outline: "",
                    type: "warning",
                    value: _vm.isStateNext,
                  },
                },
                [
                  _c("div", { staticClass: "primary--text" }, [
                    _vm._v(
                      "\n          Cofactors without a default value were found. The current strategy requires default values to be set.\n          Without a default value, the system may not be able to calculate guideline values.\n          See the alerts at the top of this page to determine which cofactors don't have a default value.\n        "
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-actions",
        [
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { color: "success", disabled: !_vm.enableSubmitStatus },
              on: {
                click: function ($event) {
                  return _vm.$emit("save")
                },
              },
            },
            [
              _c("v-icon", {
                staticClass: "mr-1",
                domProps: {
                  innerHTML: _vm._s(_vm.isStateNext ? "navigate_next" : "done"),
                },
              }),
              _vm._v("\n      " + _vm._s(_vm.proceedButtonText) + "\n    "),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              on: {
                click: function ($event) {
                  return _vm.$emit("cancel")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }